import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { Contact as ContactPayload } from 'APP/main/ChatView/Messages/Message/Payload/Contact';

import styles from './styles.m.scss';

const Contact = ({ message }) => {
  return (
    <div className={styles.container}>
      <ContactPayload
        message={message}
        className={styles.contact}
        avatarType={AvatarTypes.Round_5}
      />
    </div>
  );
};

export default Contact;
